import * as THREE from 'three';

export function takeScreenshot(scene: any, camera: any, filename = 'screenshot') {
  const screenshotWidth = 1920; // Desired width
  const screenshotHeight = 1080; // Desired height

  // Create a WebGLRenderer with alpha (transparency) enabled
  const renderer = new THREE.WebGLRenderer({ alpha: true, preserveDrawingBuffer: true });
  renderer.setSize(screenshotWidth, screenshotHeight, false);

  // Ensure the scene background is transparent
  scene.background = null;

  // Render the current frame
  renderer.render(scene, camera);

  // Capture the canvas as a data URL
  const screenshotDataUrl = renderer.domElement.toDataURL('image/png');

  // Create a link to download the screenshot
  const link = document.createElement('a');
  link.href = screenshotDataUrl;
  link.download = filename + '.png';
  link.click();

  // Clean up
  renderer.dispose();
}
